module.exports = __webpack_public_path__ + "img/edgard-lallali.39ef67ce.jpg";